/**************************************************
 * Nombre:       Seccion_Inicio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Tarjeta_Deposito from "../Tarjetas_Especiales/Tarjeta_Deposito";
import Lista_Contratos from "./Componentes/Lista_Contratos";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Contrato from "../Dialogos/Dialogo_Contrato";
import {useEffect, useState} from "react";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Contratos = () => {
    const {sCell} = useResponsive()

    useEffect(() => {
       irArriba()
    },[])
    return (
        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', color: 'white', pb: 10}}
                spacing={4}
            >


                <Grid container size={{xs: 12, sm: 6, md: 5}} sx={{justifyContent: 'flex-start', mt: 8}}>
                    <Tarjeta_Deposito />
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 5}} sx={{justifyContent: 'flex-start', mt: sCell ? 0 :  8}}>

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 16, fontWeight: 700}}>Lista de contratos</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mt: 0}}>
                    <Lista_Contratos/>
                </Grid>


            </Grid>
        </Grid>
    )

}
export default Seccion_Contratos